// extracted by mini-css-extract-plugin
module.exports = {"container":"q_bd","logosTitle":"q_bt","logosList":"q_bw"};